import debounce from 'lodash-es/debounce';
import { ref } from 'vue';

export const useBirthPlaces = (lookupBirthPlaces) => {
	const birthPlaces = ref([]);

	const capitalize = (str) => str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();

	const lookupCity = debounce(async (query) => {
		if (query.length < 2) {
			birthPlaces.value = [];
			return;
		}

		try {
			const response = await lookupBirthPlaces(query);
			birthPlaces.value = response.data.map(capitalize);
		} catch (error) {
			console.error('Failed to fetch birth places:', error);
			birthPlaces.value = [];
		}
	}, 300);

	const setAndLookupCity = (query) => {
		lookupCity(query.trim());
	};

	return { birthPlaces, setAndLookupCity };
};
